import { ReservationHotelRoomDetailsModel } from "src/models/ReservationHotelRoomDetailsModel";
import { providerHelpers, transformRoomByProvider } from "src/utils/providerConfig";

export const transformToHotelRoomDetails = (data, hotels = []) => {
    if (!data) return null;

    const hotelMessages = providerHelpers.extractHotelMessages(data.Provider, data);

    data.RoomRequestResults?.forEach((request) => {
        request.Rooms = request.Rooms.map((room) => {
            const transformedRoom = transformRoomByProvider(data.Provider, room);
            
            return {
                ...transformedRoom,
                RoomCount: 0,
                TotalCost: 0,
                SupplementResults: room.SupplementResults?.map(supp => ({
                    ...supp,
                    Selected: supp.Included ?? false
                })) || [],
                DiscountResults: room.DiscountResults?.map(disc => ({
                    ...disc,
                    UserIncluded: disc.Included ?? false
                })) || [],
            };
        });
    });

    return { ...new ReservationHotelRoomDetailsModel(data, hotels, hotelMessages) };
};